import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	method: string
	isSlim?: boolean
}

export const Method = styled.span.attrs<Props>(({ method }) => ({
	children: method,
}))<Props>`
	border-radius: 4px;
	word-break: normal;
	padding: 0 4px;
	font-weight: ${({ isSlim }) => (isSlim ? 400 : 500)};
	font-family: ${helpers.font.family.header};
	font-size: ${({ isSlim, theme }) => (isSlim ? theme.font.size.smaller : 'inherit')};
	text-transform: uppercase;
	color: ${helpers.color.textContrast};
	background-color: ${({ method, theme }) => {
		switch (method) {
			case 'get':
				return theme.color.success
			case 'post':
				return theme.color.warning
			case 'put':
				return theme.color.link
			case 'patch':
				return theme.color.text
			case 'delete':
				return theme.color.error
		}
	}};
`
